<template>
  <header id="header" class="site-header">
    <div class="header-bar">
      <router-link to="/" class="brand" @click.native="navClick(0)">
        <span class="brand-mark">PL</span>
        <span class="brand-copy">
          <strong>攀临科技</strong>
          <small>Software Development</small>
        </span>
      </router-link>

      <nav class="desktop-nav" aria-label="主导航">
        <div
          v-for="(item, index) in navList"
          :key="item.name"
          :class="['nav-cell', { active: index === navIndex, dropdown: item.children.length > 0 }]"
          @click="navClick(index)"
        >
          <router-link :to="item.path" class="nav-link">
            {{ item.name }}
          </router-link>
          <div v-if="item.children.length > 0" class="submenu">
            <router-link
              v-for="child in item.children"
              :key="child.name"
              :to="child.path"
              class="submenu-link"
            >
              <strong>{{ child.name }}</strong>
              <span>{{ child.desc }}</span>
            </router-link>
          </div>
        </div>
      </nav>

      <div class="header-action">
        <a href="tel:15622317013" class="phone">15622317013</a>
        <router-link to="/contactus" class="quote-btn" @click.native="navClick(5)">咨询开发</router-link>
      </div>

      <button class="menu-button" type="button" aria-label="打开菜单" @click="toggleMobileMenu">
        <span></span>
        <span></span>
      </button>
    </div>

    <div class="mobile-panel" :class="{ active: mobileMenuOpen }">
      <div class="mobile-head">
        <span>菜单</span>
        <button type="button" aria-label="关闭菜单" @click="closeMobileMenu">×</button>
      </div>
      <router-link
        v-for="(item, index) in navList"
        :key="item.name"
        :to="item.path"
        class="mobile-link"
        @click.native="navClick(index); closeMobileMenu()"
      >
        {{ item.name }}
      </router-link>
      <router-link to="/contactus" class="mobile-quote" @click.native="navClick(5); closeMobileMenu()">
        获取软件开发报价
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? parseInt(sessionStorage.getItem('navIndex')) : 0,
      mobileMenuOpen: false,
      navList: [
        { name: "首页", path: "/", children: [] },
        {
          name: "软件产品",
          path: "/software",
          children: [
            { name: "车辆管理系统", path: "/software/smartTown", desc: "车辆档案、审批、费用与报表" },
            { name: "大数据管理系统", path: "/software/bigData", desc: "数据采集、分析与可视化平台" }
          ]
        },
        { name: "开发服务", path: "/service", children: [] },
        { name: "案例资讯", path: "/newsinformation", children: [] },
        { name: "关于团队", path: "/companyintroduction", children: [] },
        { name: "联系我们", path: "/contactus", children: [] }
      ]
    };
  },
  methods: {
    navClick(index) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index);
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.style.overflow = '';
    }
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 18px;
  left: 0;
  right: 0;
  z-index: 2000;
  padding: 0 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  pointer-events: none;
}

.header-bar {
  width: min(1180px, 100%);
  height: 68px;
  margin: 0 auto;
  padding: 0 14px 0 18px;
  display: grid;
  grid-template-columns: 230px minmax(440px, 1fr) 230px;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  background: rgba(9, 10, 12, 0.82);
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(22px);
  pointer-events: auto;
}

.brand {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  text-decoration: none;
}

.brand:hover,
.nav-link:hover,
.phone:hover,
.quote-btn:hover,
.submenu-link:hover,
.mobile-link:hover,
.mobile-quote:hover {
  text-decoration: none;
}

.brand-mark {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #0b0b0a;
  background: linear-gradient(135deg, #fff, #9ec5ff);
  font-size: 14px;
  font-weight: 900;
}

.brand-copy {
  min-width: 0;
}

.brand-copy strong,
.brand-copy small {
  display: block;
  white-space: nowrap;
}

.brand-copy strong {
  color: #fff;
  font-size: 16px;
  font-weight: 850;
  line-height: 1.15;
}

.brand-copy small {
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.46);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.desktop-nav {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 100%;
}

.nav-cell {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-link {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 13px;
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  font-weight: 750;
  line-height: 1;
  white-space: nowrap;
  transition: color .2s ease, background .2s ease;
}

.nav-cell.active .nav-link,
.nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.105);
}

.submenu {
  position: absolute;
  top: calc(100% - 3px);
  left: 50%;
  width: 300px;
  padding: 10px;
  border: 1px solid rgba(255,255,255,.12);
  border-radius: 22px;
  background: rgba(14, 15, 18, .96);
  box-shadow: 0 28px 80px rgba(0,0,0,.42);
  backdrop-filter: blur(22px);
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, 10px);
  transition: opacity .2s ease, transform .2s ease, visibility .2s ease;
}

.dropdown:hover .submenu {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
}

.submenu:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -14px;
  height: 14px;
}

.submenu-link {
  display: block;
  padding: 14px;
  border-radius: 16px;
  color: #fff;
}

.submenu-link:hover {
  color: #fff;
  background: rgba(255,255,255,.08);
}

.submenu-link strong,
.submenu-link span {
  display: block;
}

.submenu-link strong {
  font-size: 14px;
  font-weight: 850;
}

.submenu-link span {
  margin-top: 5px;
  color: rgba(255,255,255,.52);
  font-size: 12px;
  line-height: 1.5;
}

.header-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.phone {
  color: rgba(255,255,255,.56);
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
}

.phone:hover {
  color: #fff;
}

.quote-btn,
.mobile-quote {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border-radius: 999px;
  color: #0b0b0a;
  background: #eef4ff;
  font-size: 14px;
  font-weight: 850;
  white-space: nowrap;
  box-shadow: 0 10px 30px rgba(138,180,255,.20);
}

.quote-btn:hover,
.mobile-quote:hover {
  color: #0b0b0a;
}

.menu-button {
  display: none;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  background: rgba(255,255,255,.1);
}

.menu-button span {
  display: block;
  width: 18px;
  height: 2px;
  margin: 5px auto;
  border-radius: 999px;
  background: #fff;
}

.mobile-panel {
  display: none;
}

@media (max-width: 1100px) {
  .header-bar {
    grid-template-columns: 210px 1fr 170px;
  }

  .phone {
    display: none;
  }

  .nav-link {
    padding: 0 10px;
    font-size: 13px;
  }
}

@media (max-width: 860px) {
  .site-header {
    top: 12px;
    padding: 0 14px;
  }

  .header-bar {
    height: 60px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px 0 14px;
  }

  .desktop-nav,
  .header-action {
    display: none;
  }

  .brand-mark {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }

  .brand-copy small {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .mobile-panel {
    position: fixed;
    top: 86px;
    left: 14px;
    right: 14px;
    display: block;
    padding: 18px;
    border: 1px solid rgba(255,255,255,.12);
    border-radius: 28px;
    background: rgba(9, 10, 12, .96);
    box-shadow: 0 24px 80px rgba(0,0,0,.42);
    backdrop-filter: blur(22px);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-8px);
    transition: opacity .2s ease, transform .2s ease, visibility .2s ease;
    pointer-events: auto;
  }

  .mobile-panel.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .mobile-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    color: #fff;
    font-weight: 850;
  }

  .mobile-head button {
    border: 0;
    color: #fff;
    background: transparent;
    font-size: 26px;
    line-height: 1;
  }

  .mobile-link {
    display: block;
    padding: 14px 4px;
    border-top: 1px solid rgba(255,255,255,.08);
    color: rgba(255,255,255,.78);
    font-size: 16px;
    font-weight: 800;
  }

  .mobile-link:hover {
    color: #fff;
  }

  .mobile-quote {
    width: 100%;
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue